var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleHandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,1.67c5.7,0,10.33,4.64,10.33,10.33S17.7,22.33,12,22.33S1.67,17.7,1.67,12S6.3,1.67,12,1.67 M12,0.67 C5.74,0.67,0.67,5.74,0.67,12S5.74,23.33,12,23.33S23.33,18.26,23.33,12S18.26,0.67,12,0.67L12,0.67z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,3.76c4.54,0,8.24,3.7,8.24,8.24s-3.7,8.24-8.24,8.24S3.76,16.54,3.76,12S7.46,3.76,12,3.76 M12,2.76 C6.9,2.76,2.76,6.9,2.76,12S6.9,21.24,12,21.24s9.24-4.14,9.24-9.24S17.1,2.76,12,2.76L12,2.76z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,9.13c1.58,0,2.87,1.29,2.87,2.87s-1.29,2.87-2.87,2.87S9.13,13.58,9.13,12S10.42,9.13,12,9.13 M12,8.13 c-2.14,0-3.87,1.73-3.87,3.87s1.73,3.87,3.87,3.87s3.87-1.73,3.87-3.87S14.14,8.13,12,8.13L12,8.13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleHandle);
export default __webpack_public_path__ + "static/media/circle_handle.644eabc9329fb6cd5c68e6e0648c16dd.svg";
export { ForwardRef as ReactComponent };